import { graphql } from '~/lib/graphql'

export const ReserveInfoMember = graphql(`
  fragment ReserveInfoMember on ReserveInfo {
    member {
      __typename
      name
      nameKana
      phoneNumber
      email
      ...MemberDiscountCoupons
      ...MemberCards
      paypay {
        __typename
        ... on PaypayAvailable {
          balance
        }
        ... on PaypayUnavailable {
          cause
        }
        __typename
      }
      totalPoint
      usablePoint
      mailMagazineSubscription {
        restaurant
        point
        present
      }
    }
  }
`)
